"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var attr_1 = require("../trait/attr");
var type_object_1 = require("../../../core/lang/type-object");
exports.attr = function (typeOrPrototype, propName) {
    if (typeOrPrototype === void 0) { typeOrPrototype = attr_1.DEFAULT_ATTR_TYPE; }
    if (propName === void 0) { propName = undefined; }
    if (typeof typeOrPrototype !== type_object_1.TYPE_OBJECT) {
        // support for @attr(ATTR_TYPE.?) with support for custom set ATTR_TYPE
        return function (prototype, propName) {
            attr_1.AttrTrait.addAttr(prototype.constructor, propName, typeOrPrototype);
        };
    }
    else {
        // support for @attr with default ATTR_TYPE
        attr_1.AttrTrait.addAttr(typeOrPrototype.constructor, propName, attr_1.DEFAULT_ATTR_TYPE);
    }
};
//# sourceMappingURL=attr.js.map